import { render, staticRenderFns } from "./Chi_chineseNewYearItem.vue?vue&type=template&id=0e1f546d&scoped=true"
import script from "./Chi_chineseNewYearItem.vue?vue&type=script&lang=ts"
export * from "./Chi_chineseNewYearItem.vue?vue&type=script&lang=ts"
import style0 from "./Chi_chineseNewYearItem.vue?vue&type=style&index=0&id=0e1f546d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1f546d",
  null
  
)

export default component.exports